import script from "./card.vue?vue&type=script&setup=true&lang=js"
export * from "./card.vue?vue&type=script&setup=true&lang=js"

import "./card.vue?vue&type=style&index=0&id=c8787444&lang=scss"

const __exports__ = script;

export default __exports__